/**
 * Detect when the bot is delivering the Strategic Hook “pricing / calendar” handoff
 * so the meeting UI can show the calendar follow-up sheet.
 *
 * The playbook allows paraphrase, so we match overlapping signals instead of one fixed script.
 */

function normalizeForMatch(s) {
  return String(s || '')
    .replace(/\u2019/g, "'")
    .replace(/\u2018/g, "'")
    .replace(/\u2014/g, '-')
    .toLowerCase();
}

/**
 * @param {string} text Cumulative AI transcript chunk or full reply
 * @returns {boolean}
 */
export function shouldOpenCalendarFollowupSheet(text) {
  const t = normalizeForMatch(text);
  if (t.length < 28) return false;

  const hasCalendar =
    t.includes('calendar link') ||
    (t.includes('calendar') && (t.includes('link') || t.includes('send') || t.includes('sending'))) ||
    t.includes('scheduling link');

  const hasPricingAngle =
    t.includes('pricing') ||
    t.includes('how much') ||
    t.includes('cost') ||
    t.includes('talk numbers') ||
    (t.includes('price') && (t.includes('custom') || t.includes('plan') || t.includes('quote')));

  const strategistNotAe =
    t.includes('strategist') &&
    (t.includes('account executive') ||
      t.includes('account exec') ||
      t.includes('not an account') ||
      t.includes('not the ae') ||
      t.includes('not an ae'));

  /** “Not the account exec…” without saying “strategist” */
  const execSelfEfface =
    t.includes('not an account executive') ||
    t.includes('not the account executive') ||
    t.includes('not an account exec') ||
    t.includes('not an ae') ||
    t.includes('not the ae') ||
    (t.includes('i am not the') && t.includes('account'));

  const humanOrBrief =
    t.includes('real person') ||
    (t.includes('brief') && t.includes('team')) ||
    (t.includes('follow-up') && (t.includes('calendar') || t.includes('team') || t.includes('pricing')));

  // Original Phase-7 shape (verbatim-style)
  if (
    strategistNotAe &&
    (hasCalendar ||
      (t.includes('calendar') && t.includes('sending')) ||
      t.includes('real person on the line') ||
      (t.includes('talk numbers') && t.includes('workflow')))
  ) {
    return true;
  }

  // Calendar + pricing / strategist / AE handoff / brief — paraphrased pivots
  if (hasCalendar && (hasPricingAngle || strategistNotAe || execSelfEfface || humanOrBrief)) {
    return true;
  }

  // Strong pricing reply + next step to meet / schedule / calendar
  if (
    hasPricingAngle &&
    (hasCalendar ||
      t.includes('book a') ||
      t.includes('schedule') ||
      (t.includes('on the line') && (t.includes('person') || t.includes('human'))))
  ) {
    return true;
  }

  return false;
}
